import React from "react";

export default function statusOrganisator(){
	return (<svg id="Laag_1" viewBox="12 12 56 56" width="51px" height="80px">
		<g fill="none" stroke="#FF8200" strokeMiterlimit="10" strokeWidth="1.5">
			<path d="M58.56,54.92v-6.22c0-3.57-2.89-6.46-6.46-6.46-2.41,0-4.51,1.32-5.62,3.28"/>
			<path d="M33.48,45.46c-1.12-1.93-3.2-3.22-5.59-3.22-3.57,0-6.46,2.89-6.46,6.46v6.22"/>
			<circle cx="27.9" cy="34.26" r="5.08"/>
			<circle cx="52.1" cy="34.26" r="5.08"/>
			<circle cx="40" cy="30.57" r="5.08"/>
			<path d="M46.46,54.92v-9.91c0-3.57-2.89-6.46-6.46-6.46s-6.46,2.89-6.46,6.46v9.91"/>
		</g>
	</svg>);
}
